import type { DashboardStoreType } from './dashboard-store.types';
import { initialDashboard } from './dashboard-store.types';

export interface DashboardLibraryState {
  readonly dashboard: DashboardStoreType;
}

export const initialDashboardLibraryState: DashboardLibraryState = {
  dashboard: initialDashboard,
};
